import { EditGame } from '../c/GameParams';
export default EditGame;



// WEBPACK FOOTER //
// ./src/p/EditGame.js